import React, { useState } from 'react';
import '../styles/portfolioComponent.css';
import Header from './headerComponent.jsx';
import Home from './HomeComponent';
import AboutMe from './aboutMeComponent.jsx';
import Projects from './projectsComponent.jsx';
import ContactMe from './contactComponent.jsx';

export default function Portfolio(props) {
  const [language, setLanguage] = useState('es');
  const [h1, setH1] = useState('Algunos proyectos')
  const toggleLanguage = () => {
    if (language === 'es') {
      setLanguage('en');
      setH1('Some projects');
    } else {
      setLanguage('es');
      setH1('Algunos proyectos');
    }
  };


  return (
    <div className="portfolioDiv">
      <Header
        home={language === 'es' ? 'Inicio' : 'Home'}
        about={language === 'es' ? 'Acerca de' : 'About'}
        projects={language === 'es' ? 'Proyectos' : 'Projects'}
        contact={language === 'es' ? 'Contactame' : 'Contact me'}
        toggleLanguage={toggleLanguage}
        button={language === 'es' ? 'Español' : 'English'}
      />

      <div id="Home" className="bodyHome">
        <Home
          h1={language === 'es' ? 'Hola! bienvenido a mi ' : 'Hi! Welcome to my '}
          span1={language === 'es' ? 'portafolio ' : 'portfolio '}
          h2={language === 'es' ? 'Y yo soy ' : "And I'm "}
          span2={language === 'es' ? 'Desarrollador Web ' : 'Web developer '}
          download={language === 'es' ? 'Descargar CV' : 'Download CV'}
        />

      </div>
      <div id="About" className="bodyAboutMe">
        <AboutMe
          AboutMe={language === 'es' ? 'Sobre mi:' : 'About Me:'}
          technologies={language === 'es' ? 'Tecnologias:' : 'Technologies:'}
          talented={language === 'es' ? 'Talentoso ' : 'talented '}
          and={language === 'es' ? 'y ' : 'and '}
          passionate={language === 'es' ? 'apasionado ' : 'passionate '}
          developer={language === 'es' ? 'Desarrollador Full-Stack ' : 'full-stack developer '}
          experiences={
            language === 'es'
              ? 'con experiencia en HTML, CSS, JavaScript, Angular, React, Nodejs, y Expressjs. Trabajé en '
              : 'with experience in HTML, CSS, JavaScript, Angular, React, Nodejs, and Expressjs. Worked on '
          }
          front={language === 'es' ? 'Front-End ' : 'Front-End '}
          back={language === 'es' ? 'Back-End ' : 'Back-End '}
          projects={
            language === 'es'
              ? 'proyectos. Comprometido con el aprendizaje continuo y la mejora de habilidades. Prospera en entornos de colaboración, construyendo relaciones sólidas con sus compañeros de equipo y tomando una '
              : 'projects. Committed to continuous learning and skill improvement. Thrives in collaborative environments, building strong relationships with teammates and taking a'
          }
          proactive={language === 'es' ? ' actitud proactiva. ' : ' proactive approach. '}
          solutions={
            language === 'es'
              ? 'Siempre buscando oportunidades para crear soluciones creativas y efectivas. '
              : 'Always seeking opportunities to create creative and effective solutions. '
          }
          frase={language === 'es' ? 'Si puedes soñarlo puedes programarlo ' : 'If you can dream it, you can program it. '}
        />
      </div>
      <div id="Projects" className="bodyProjects">
        <h1>{h1}</h1>
        <Projects
          memorama={language === 'es' ? 'Juego de memoria hecho solo con html y css ' : 'A memory game make just with css and html '}
          pesebre={language === 'es' ? 'Un proyecto para el segundo cooding bootcamp ' : 'A project for segundo cooding bootcamp '}
          hexadecimal={language === 'es' ? 'Practica js y eventos ' : 'Practice for js and events '}
          api={language === 'es' ? ' consumiendo APis ' : 'Practice consuming an APIs '}
          angular={language === 'es' ? 'Tienda "real" con angular ' : 'A "real" angular store '}
          react={language === 'es' ? 'Tienda "real" con react ' : 'A "real" react store '}
        />
      </div>
      <div id="ContactMe" className="bodyContactme">
        <ContactMe
          contact={language === 'es' ? 'Contactame' : 'Contact me'}
          name={language === 'es' ? 'Nombre Completo' : 'Full Name'}
          email={language === 'es' ? 'Correo Electronico' : 'Email'}
          example={language === 'es' ? 'ejemplo@domio.com' : 'example@domain.com'}
          subject={language === 'es' ? 'Asunto' : 'Subject'}
          subjecttype={language === 'es' ? 'Escribe el asunto' : 'Write the subject'}
          message={language === 'es' ? 'Mensaje' : 'Message'}
          messagetype={language === 'es' ? 'Escribe tu mensaje' : 'Write your message'}
          submit={language === 'es' ? 'Enviar' : 'Submit'}
        />
        <footer>
          <div className="foot">
            <p>© 2023 Santiago Mejia Ocampo</p>
          </div>
        </footer>
      </div>
    </div>
  )
}





